"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageImageComponent = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importStar(require("react"));
var PageImageComponent = function (props) {
    var image = props.image, title = props.title, description = props.description;
    (0, react_1.useEffect)(function () { }, []);
    return (react_1.default.createElement("div", { className: "relative rounded-lg overflow-hidden shadow-lg" },
        react_1.default.createElement("div", { className: "h-[600px] w-full" },
            react_1.default.createElement("div", { className: "bg-[#00000044] h-full w-full absolute" }),
            react_1.default.createElement("img", { className: "h-full w-full object-cover ", src: image })),
        react_1.default.createElement("div", { className: "absolute top-10 left-10 drop-shadow flex flex-col gap-4" },
            react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "4xlarge", textColor: "text-white", label: title, bold: true }),
            react_1.default.createElement("div", { className: "max-w-[350px]" },
                react_1.default.createElement(doshx_controls_web_1.LabelControl, { size: "medium", textColor: "text-white", bold: true, label: description })))));
};
exports.PageImageComponent = PageImageComponent;
